/**
 * jn-size-toggle.js
 * ---------------------------------------------------------------------------
 * "In my size" toggle shown above the filters on collection pages.
 *
 *  - If the visitor already has a size cookie (jfq_bra_sz / jfq_dress_sz, set by
 *    the fit quiz or the size popups), turning the toggle on applies the matching
 *    size filters to the collection.
 *  - If there is no size cookie, turning it on opens the fit-quiz modal so they
 *    can set one; once the quiz saves a size, the matching filters are applied.
 *  - Turning it off removes the size filters again.
 *
 * The toggle is rendered (hidden) by snippets/facets.liquid and lives OUTSIDE
 * <facets-form> so its change event never triggers the form's update-on-change
 * submit. Cookie formats mirror jn-facets-quiz.js / jn-for-you.js.
 */
(function () {
  'use strict';

  // ---- cookies ------------------------------------------------------------
  function getCookie(n) {
    var c = document.cookie.split(';').map(function (s) { return s.trim(); })
      .find(function (s) { return s.startsWith(n + '='); });
    return c ? decodeURIComponent(c.slice(n.length + 1)) : null;
  }

  var braSize = null;
  var pantySize = null;

  function parseCookies() {
    braSize = null;
    try { braSize = JSON.parse(getCookie('jfq_bra_sz') || 'null'); } catch (e) {}
    if (braSize && (!braSize.band || !braSize.cup)) braSize = null;

    pantySize = null;
    try {
      var raw = getCookie('jfq_dress_sz') || localStorage.getItem('jfq_dress_sz');
      var ds = JSON.parse(raw || 'null');
      pantySize = (ds && ds.pantySize) ? ds.pantySize : null;
    } catch (e) {}
  }

  // ---- size aliasing (mirrors jn-facets-quiz.js) --------------------------
  var PANTY_SIZE_ALIASES = {
    XS:  ['XS', 'EXTRA SMALL', 'X-SMALL', 'X SMALL', 'X-S'],
    S:   ['S', 'SMALL'],
    M:   ['M', 'MEDIUM'],
    L:   ['L', 'LARGE'],
    XL:  ['XL', 'EXTRA LARGE', 'X-LARGE', 'X-L'],
    XXL: ['XXL', 'EXTRA EXTRA LARGE', '2XL', 'XX-LARGE']
  };

  // DD<->E and DDD<->F — Shopify groups them as "DD/E" and "DDD/F"
  var CUP_ALIASES = {
    DD:  ['DD', 'E', 'DD/E'],
    E:   ['DD', 'E', 'DD/E'],
    DDD: ['DDD', 'F', 'DDD/F'],
    F:   ['DDD', 'F', 'DDD/F']
  };
  function cupForms(cup) { return CUP_ALIASES[String(cup).toUpperCase()] || [cup]; }
  function sizeForms(band, cup) { return cupForms(cup).map(function (c) { return String(band) + c; }); }

  // ---- input discovery ----------------------------------------------------
  function sizeInputs(form) {
    var groups = { band: [], cup: [], size: [] };
    if (!form) return groups;
    form.querySelectorAll('input[name]').forEach(function (inp) {
      var name = inp.name.toLowerCase();
      if (name.indexOf('filter') !== 0) return;
      if (name.indexOf('band-size') > -1 || name.indexOf('band_size') > -1) groups.band.push(inp);
      else if (name.indexOf('cup-size') > -1 || name.indexOf('cup_size') > -1) groups.cup.push(inp);
      else if (name === 'filter.v.option.size' ||
               (name.slice(-5) === '.size' && name.indexOf('band') === -1 && name.indexOf('cup') === -1)) {
        groups.size.push(inp);
      }
    });
    return groups;
  }

  function labelFor(inp) {
    var ctrl = inp.closest('.checkbox-control');
    var txt = '';
    if (ctrl) { var l = ctrl.querySelector('label'); if (l) txt = l.textContent; }
    return txt.replace(/\s*\(\d+\)\s*$/, '').trim();
  }

  // Match by input value first, then by (count-stripped) label text.
  function matchInput(inputs, values) {
    var strs = values.map(String);
    var upper = strs.map(function (v) { return v.toUpperCase(); });
    for (var i = 0; i < inputs.length; i++) {
      if (strs.indexOf(inputs[i].value) > -1) return inputs[i];
    }
    for (var j = 0; j < inputs.length; j++) {
      if (upper.indexOf(labelFor(inputs[j]).toUpperCase()) > -1) return inputs[j];
    }
    return null;
  }

  // Which inputs to check for the visitor's saved size on this collection.
  function computeTargets(form) {
    var g = sizeInputs(form);
    var hasBraFilters = g.band.length > 0 || g.cup.length > 0;
    var hasSizeFilter = g.size.length > 0;

    if (braSize) {
      var targets = [];
      if (g.band.length) { var bi = matchInput(g.band, [String(braSize.band)]); if (bi) targets.push(bi); }
      if (g.cup.length)  { var ci = matchInput(g.cup, cupForms(braSize.cup)); if (ci) targets.push(ci); }
      if (!targets.length && g.size.length) {
        var si = matchInput(g.size, sizeForms(braSize.band, braSize.cup));
        if (si) targets.push(si);
      }
      if (targets.length) return { targets: targets, kind: 'bra', hasBraFilters: hasBraFilters, hasSizeFilter: hasSizeFilter };
    }

    if (pantySize && g.size.length) {
      var ps = String(pantySize).toUpperCase();
      var vals = PANTY_SIZE_ALIASES[ps] || [ps];
      var psi = matchInput(g.size, vals);
      if (psi) return { targets: [psi], kind: 'panty', hasBraFilters: hasBraFilters, hasSizeFilter: hasSizeFilter };
    }

    return { targets: [], kind: null, hasBraFilters: hasBraFilters, hasSizeFilter: hasSizeFilter };
  }

  // ---- URL helpers --------------------------------------------------------
  function currentParams() { return new URLSearchParams(location.search); }

  function allPresent(targets) {
    if (!targets.length) return false;
    var sp = currentParams();
    return targets.every(function (t) { return sp.getAll(t.name).indexOf(t.value) > -1; });
  }

  function navigate(sp) {
    sp.delete('page');
    var qs = sp.toString();
    location.href = location.pathname + (qs ? '?' + qs : '');
  }

  function applyURL(targets) {
    var sp = currentParams();
    targets.forEach(function (t) {
      if (sp.getAll(t.name).indexOf(t.value) === -1) sp.append(t.name, t.value);
    });
    navigate(sp);
  }

  function removeURL(form) {
    var g = sizeInputs(form);
    var names = {};
    [].concat(g.band, g.cup, g.size).forEach(function (i) { names[i.name] = true; });
    var out = new URLSearchParams();
    currentParams().forEach(function (v, k) { if (!names[k]) out.append(k, v); });
    navigate(out);
  }

  // ---- fit-quiz prompt ----------------------------------------------------
  function openQuiz(form, hint, cb) {
    var g = sizeInputs(form);
    var useBra = g.band.length > 0 || g.cup.length > 0; // band/cup -> bra quiz, else letter-size quiz
    var opener = useBra ? window.jnOpenBraModal : window.jnOpenPantyModal;
    var evt = useBra ? 'jnBraSizeSet' : 'jnPantySizeSet';

    if (typeof opener !== 'function') { cb.checked = false; return; }

    var onSet = function () {
      document.removeEventListener(evt, onSet);
      parseCookies();
      var r = computeTargets(form);
      if (r.targets.length) { applyURL(r.targets); return; } // navigates away
      cb.checked = false;
      if (braSize || pantySize) showHint(hint, 'No items in your size in this collection.');
    };
    document.addEventListener(evt, onSet);
    opener();
  }

  function showHint(hint, msg) {
    if (!hint) return;
    hint.textContent = msg;
    hint.hidden = false;
    clearTimeout(hint._t);
    hint._t = setTimeout(function () { hint.hidden = true; }, 5000);
  }

  // ---- wiring -------------------------------------------------------------
  function initToggle(wrap) {
    if (wrap.dataset.jnInit === '1') return;

    var form = wrap.parentElement && wrap.parentElement.querySelector('facets-form form');
    if (!form) return;

    var cb = wrap.querySelector('[data-jn-size-toggle-input]');
    var hint = wrap.querySelector('[data-jn-size-toggle-hint]');
    if (!cb) return;

    var info = computeTargets(form);

    // No size inputs actually rendered here (e.g. the size facet is hidden) —
    // nothing to toggle, so keep it hidden.
    if (!info.hasBraFilters && !info.hasSizeFilter) { wrap.dataset.jnInit = '1'; return; }

    var relevantCookie =
      (info.hasBraFilters && braSize) ||
      (info.hasSizeFilter && (braSize || pantySize));

    // The visitor has a saved size but this collection doesn't carry it — the
    // toggle would do nothing, so leave it hidden.
    if (relevantCookie && info.targets.length === 0) { wrap.dataset.jnInit = '1'; return; }

    wrap.dataset.jnInit = '1';
    wrap.hidden = false;
    cb.checked = info.targets.length > 0 && allPresent(info.targets);

    cb.addEventListener('change', function (e) {
      e.stopPropagation();
      // Re-resolve the form in case the facets re-rendered via AJAX since init.
      var liveForm = (wrap.parentElement && wrap.parentElement.querySelector('facets-form form')) || form;
      if (cb.checked) {
        var r = computeTargets(liveForm);
        if (r.targets.length) applyURL(r.targets);  // have a size -> apply
        else openQuiz(liveForm, hint, cb);          // no size yet -> prompt quiz
      } else {
        removeURL(liveForm);
      }
    });
  }

  function init(root) {
    parseCookies();
    (root || document).querySelectorAll('[data-jn-size-toggle]').forEach(initToggle);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    init();

    // The sidebar facets re-render via AJAX when other filters change, which
    // replaces the toggle markup — re-initialise any fresh, un-wired toggles.
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { init(); }, 120);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
